import React, { useState } from 'react'
import { connect } from 'react-redux'

import { ReactModal } from '../../../../components'
import { IMG } from '../../../../themes'
import { uploadImage } from '../../../../helpers'
import { FACILITIES_STATUS, ISSUE, ISSUE_ERROR_CONTENT, ORDER_MODAL_ACTION_TEXT, OTHER, REPORT_ISSUE } from '../../../../helpers/constants'
import { ISSUE as ISSUE_REDUX, LOADER, MODAL } from '../../../../reduxs'

import { IssueReportModalStyle } from './styles'

const IssueReportModal = (props) => {
  const {
    language,
    colorTheme,
    isOpenIssueReportModal,
    facilityHashMap,
    setSelectedItem,
    setIssueDetailToStore,
    createIssue,
    detailRoom,
    addUploadImages,
    clearIssue,
    closeIssueReportModal,
    openSuccessOrderModal,
    selectedItemName,
    renderImages,
    deleteSelectedItem,
    openIssueFileLimitModal,
    setErrorModal,
    closeLoader,
  } = props
  
  const [isOpenFacilityDropdown, setIsOpenFacilityDropdown] = useState(false)
  const [issueDetail, setIssueDetail] = useState('')

  const handleCreateIssue = async (issueDetail, roomId) => {
    setIssueDetailToStore(issueDetail)

    const response = await createIssue(roomId)

    if(response.status) {
      openSuccessOrderModal() 
    } else {
      setErrorModal(true, ISSUE_ERROR_CONTENT)
    }
    closeLoader()
    closeIssueReportModal()
    clearIssue()
  }

  const handleBack = () => {
    closeIssueReportModal()
    clearIssue()
  }

  const handleSelectItem = (event, itemName) => {
    setSelectedItem(event, itemName)
    setIsOpenFacilityDropdown(false)
  }

  const handleUploadImage = (event) => {
    uploadImage(event, addUploadImages, openIssueFileLimitModal)
  }

  return (
    <ReactModal isVisible={isOpenIssueReportModal} width={640} borderRadius={8}> 
      <IssueReportModalStyle colorTheme={colorTheme}>
        <h2 className='issue-report__title'>{REPORT_ISSUE[language]}</h2>

        <div className='issue-report__content'>
          <div className='issue-report__dropdown'>
            <button
              className='issue-report__dropdown__box'
              onClick={() => setIsOpenFacilityDropdown(prev => prev = !prev)}
            >
              {selectedItemName ? selectedItemName : ISSUE.CHOOSE_ISSUE[language]}
              {isOpenFacilityDropdown 
                ? <img src={IMG['chevron_up.svg']} alt='chevron_up.svg' />
                : <img src={IMG['chevron_down.svg']} alt='chevron_down.svg' />
              }
            </button>
            <form
              className='issue-report__dropdown__select'
              style={{ display: isOpenFacilityDropdown ? 'block' : 'none' }}
            >
              <label
                className='issue-report__dropdown__option'
                onClick={() => setIsOpenFacilityDropdown(false)}
              >
                {ISSUE.OTHERS[language]}
                <input
                  type='radio'
                  value={OTHER}
                  onChange={(event) => handleSelectItem(event.target.value, ISSUE.OTHERS.EN)}
                  style={{ display: 'none' }}
                />
              </label>
              {
                Object.values(facilityHashMap).map((item, index) => {
                  return (
                      <label
                        key={`facility-${item.itemId}`}
                        className={`issue-report__dropdown__option ${item.status !== FACILITIES_STATUS.ACTIVE ? 'disabled' : ''}`}
                        onClick={() => setIsOpenFacilityDropdown(false)}
                      >
                        {item.itemName}
                        <input
                          type='radio'
                          value={item.itemId}
                          onChange={(event) => handleSelectItem(Number(event.target.value), item.itemName)}
                          style={{ display: 'none' }}
                        />
                      </label>
                  )
                })
              }
            </form>
          </div>

          <div className='issue-report__issue-detail'>
            <h3 className='issue-report__issue-detail__title'>
              {ISSUE.DETAIL[language]}:
            </h3>
            <textarea
              placeholder={ISSUE.TEXT_DETAIL[language]}
              className='issue-report__issue-detail__textarea'
              value={issueDetail}
              onChange={(event) => setIssueDetail(event.target.value)}
            />
          </div>

        
          <div className='issue-report__image-uploader'>
            <h3 className='issue-report__image-uploader__title'>
              {ISSUE.UPLOAD_IMG[language]}{' '}
              <span className='issue-report__image-uploader__title--amount'>
                {renderImages.length > 0 && '(' + renderImages.length + ')'}
              </span>
            </h3>
            <p className='issue-report__image-uploader__text'>
              {ISSUE.TEXT_UPLOAD[language]}
            </p>
            <label className='issue-report__image-uploader__label'>
              {ISSUE.CHOOSE_FILE[language]}
              <input
                className='issue-report__image-uploader__button'
                multiple
                type='file'
                accept='image/x-png,image/jpg,image/jpeg'
                onChange={(event) => handleUploadImage(event)}
              />
            </label>
          </div>

          {
            renderImages.length > 0 &&
            <div className='issue-report__uploaded-photo'>
              {
                renderImages.map(({image, name}, index) => {
                  return (
                    <div
                      key={name}
                      className='issue-report__uploaded-photo__item'
                    >
                      <img
                        alt={name}
                        className='issue-report__uploaded-photo__image'
                        src={image}
                      />
                      <p className='issue-report__uploaded-photo__text'>
                        {name}
                      </p>
                      <button
                        onClick={() => deleteSelectedItem(index)}
                        className='issue-report__uploaded-photo__delete-button'
                      >
                        <img
                          alt='cancel-icon'
                          className='issue-report__uploaded-photo__delete-icon'
                          src={IMG['x-cancel.svg']}
                        />
                      </button>
                    </div>
                  )
                })
              }
            </div>
          }
        </div>

        <div className='issue-report__button'>
          <button
            className='issue-report__button--back'
            onClick={() => handleBack()}
          >
            {ORDER_MODAL_ACTION_TEXT.BACK[language]}
          </button>
          <button
            className='issue-report__button--send'
            onClick={() => handleCreateIssue(issueDetail, detailRoom.roomId)}
            >
            {ORDER_MODAL_ACTION_TEXT.SEND[language]}
          </button>
        </div>
      </IssueReportModalStyle>
    </ReactModal>
  )
}

const mapStateToProps = ({ modalReducer, accountReducer, issueReducer, roomReducer }) => {
  return {
    colorTheme: accountReducer.user.colorThemePalette,
    isOpenIssueReportModal: modalReducer.issueModal.isOpenIssueReportModal,
    facilityHashMap: issueReducer.facilityHashMap,
    detail: issueReducer.issueDetail,
    detailRoom: roomReducer.detailRoom,
    language: accountReducer.language,
    selectedItemId: issueReducer.selectedItemId,
    selectedItemName: issueReducer.selectedItemName,
    renderImages: issueReducer.renderImages,
    file: issueReducer.imageFile,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedItem: (itemId, itemName) => dispatch(ISSUE_REDUX.action.setSelectedItem(itemId, itemName)),
    setIssueDetailToStore: (issueDetail) => dispatch(ISSUE_REDUX.action.setIssueDetail(issueDetail)),
    createIssue: (roomId) => dispatch(ISSUE_REDUX.action.createIssue(roomId)),
    addUploadImages: (file, image) => dispatch(ISSUE_REDUX.action.addUploadImages(file, image)),
    clearIssue: () => dispatch(ISSUE_REDUX.action.clearIssue()),
    closeIssueReportModal: () => dispatch(MODAL.action.setIssueReportModal(false)),
    openSuccessOrderModal: () => dispatch(MODAL.action.setSuccessOrderModal(true)),
    deleteSelectedItem: (index) => dispatch(ISSUE_REDUX.action.deleteSelectedItem(index)), 
    openIssueFileLimitModal: () => dispatch(MODAL.action.setIssueFileLimitModal(true)),
    setErrorModal: (isOpen, text) => dispatch(MODAL.action.setErrorModal(isOpen, text)),
    closeLoader: () => dispatch(LOADER.action.displayLoader(false)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueReportModal)
